import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../table/pcg-table-column.interface';

// tslint:disable:quotemark
// tslint:disable:max-line-length
// tslint:disable:whitespace
export class DailyCountMetricsVm {
	scheduled: number;
	completed: number;
	pending?: number;
	missed?: number;
	percentComplete: number;
	percentIncomplete: number;
	countDate: Date;

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'scheduled': new UntypedFormControl(0, [...(validators['scheduled'] ?? []), ...[Validators.required]]),
			'completed': new UntypedFormControl(0, [...(validators['completed'] ?? []), ...[Validators.required]]),
			'pending': new UntypedFormControl(null, [...(validators['pending'] ?? []), ...[]]),
			'missed': new UntypedFormControl(null, [...(validators['missed'] ?? []), ...[]]),
			'percentComplete': new UntypedFormControl(0, [...(validators['percentComplete'] ?? []), ...[Validators.required]]),
			'percentIncomplete': new UntypedFormControl(0, [...(validators['percentIncomplete'] ?? []), ...[Validators.required]]),
			'countDate': new UntypedFormControl('', [...(validators['countDate'] ?? []), ...[Validators.required]])
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static GetModel(fg: UntypedFormGroup): DailyCountMetricsVmFromFg {
		return new DailyCountMetricsVmFromFg(fg);
	}
}

export class DailyCountMetricsVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get scheduled(): number {
		return this.fg.get('scheduled').value;
	}
	set scheduled(val) {
		this.fg.get('scheduled').setValue(val);
	}

	get completed(): number {
		return this.fg.get('completed').value;
	}
	set completed(val) {
		this.fg.get('completed').setValue(val);
	}

	get pending(): number {
		return this.fg.get('pending').value;
	}
	set pending(val) {
		this.fg.get('pending').setValue(val);
	}

	get missed(): number {
		return this.fg.get('missed').value;
	}
	set missed(val) {
		this.fg.get('missed').setValue(val);
	}

	get percentComplete(): number {
		return this.fg.get('percentComplete').value;
	}
	set percentComplete(val) {
		this.fg.get('percentComplete').setValue(val);
	}

	get percentIncomplete(): number {
		return this.fg.get('percentIncomplete').value;
	}
	set percentIncomplete(val) {
		this.fg.get('percentIncomplete').setValue(val);
	}

	get countDate(): Date {
		return this.fg.get('countDate').value;
	}
	set countDate(val) {
		this.fg.get('countDate').setValue(val);
	}
}
